import { ReactNode } from 'react';
import './action.scss';
import { Button } from '../form/button';

export const Action = ({
  onClick,
  icon,
  title,
  type,
  ...props
}: {
  onClick: () => void;
  icon: ReactNode;
  title?: string;
  type?: string;
}) => {
  return (
    <Button
      className={`action ${type}`}
      title={title}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
      {...props}
    >
      {icon}
    </Button>
  );
};

export const ActivateAction = ({ onClick, ...props }: { onClick: () => void }) => {
  return (
    <Action
      onClick={onClick}
      icon={<i className="fa-solid fa-check"></i>}
      title="Activate"
      type="activate"
      {...props}
    />
  );
};

export const DeactivateAction = ({ onClick, ...props }: { onClick: () => void }) => {
  return (
    <Action
      onClick={onClick}
      icon={<i className="fa-solid fa-check"></i>}
      title="De-activate"
      type="deactivate"
      {...props}
    />
  );
};

export const DeleteAction = ({ onClick, ...props }: { onClick: () => void }) => {
  return (
    <Action onClick={onClick} icon={<i className="fa fa-trash-can"></i>} title="Delete" type="delete" {...props} />
  );
};

export const EditAction = ({ onClick, ...props }: { onClick: () => void }) => {
  return <Action onClick={onClick} icon={<i className="fa fa-pen"></i>} title="Edit" type="edit" {...props} />;
};
